<template>
    <div>
        <sub-menu-laudos ativo="lista"></sub-menu-laudos>

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load(false)" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" :class="filtro.id_unidade_operacao ? 'text-success' : ''" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtro.id_unidade_operacao">
                                <option value="">Unidades...</option>
                                <option v-for="(und, iux) in $util.unidades_com_tags(false, true)"
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col col-12 col-md-3">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fas fa-concierge-bell fa-fw" :class="filtro.id_recepcao ? 'text-success' : ''" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtro.id_recepcao" :disabled="!filtro.id_unidade_operacao">
                                <option value="">Recepção...</option>
                                <template v-if="filtro.id_unidade_operacao && $util.unidade_operacao(filtro.id_unidade_operacao)">
                                    <option v-for="(rec, irx) in $util.unidade_operacao(filtro.id_unidade_operacao).recepcaos"
                                        :value="rec.id_recepcao" :key="irx">{{ rec.search }}</option>
                                </template>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa fa-calendar-o fa-fw"
                            placeholder="Atendimento" 
                            type="select" 
                            :optionsList="[
                                { id: 'L', search: 'Atualização' }, 
                                { id: 'E', search: 'Entrega' }, 
                            ]"
                            optionsData="id" 
                            v-model="filtro.tipo_data" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            :optionsList="[
                                { id: 'DA', search: 'Atendimento' },
                                { id: 'DE', search: 'Entrega' },
                                { id: 'ID', search: 'Idade Paciente' },
                                { id: 'P', search: 'Paciente' },
                                { id: 'UR', search: 'Urgência' }
                            ]"
                            optionsData="id"
                            v-model="filtro.tipo_ordem">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-secondary" @click="filtro.ordem_dir = ( filtro.ordem_dir == 'A' ? 'D' : 'A' )">
                                        <i class="fa-solid fa-arrow-down-short-wide fa-fw" v-if="filtro.ordem_dir == 'A'"></i>
                                        <i class="fa-solid fa-arrow-down-wide-short fa-fw" v-else></i>
                                    </button>
                                </div>
                            </template>

                    </az-input>
                    </div>
                    <div class="col col-12 col-md-5">
                        <az-input icon="fa fa-search fa-fw" v-model="search" @input="refresh_se_necessario()" @onEnter="load(false)">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <print-export printid="lista-de-trabalho" v-if="false" />

                                    <relatorios-linkados
                                        pagina="laudos"
                                        :parms="{ 
                                            medico: $store.state.user.id_pessoa,
                                            laudo_id: lista.map(item => item.id_laudo),
                                        }"
                                        :outros="[
                                            { title: 'Listagem', callback: imprimirLista }
                                        ]"
                                    />
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Selecionar paciente..."
                            icon="fas fa-user fa-fw"
                            type="autocomplete"
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="paciente"
                            :optimized_ac="true" />
                    </div>
                </div>

                <div class="form-row mt-2" v-if="filas && filas.length">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            optionsMode="aql"
                            service="status_laudos.index"
                            optionsData="id_status_laudo"
                            placeholder="Todos os status..."
                            icon="fa fa-filter fa-fw"
                            v-model="filtro.id_status_laudo" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input  
                            type="checkbox-group"
                            label="Ocultar Prontos"
                            v-model="filtro.block_prontos" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input  
                            type="checkbox-group"
                            label="Agrupar por Status"
                            v-model="agrupar_por_status" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <template v-if="$store.state.user.medico">
                            <az-input
                                type="checkbox-group"
                                label="Meus Exames"
                                v-model="meus" />
                        </template>
                        <template v-else>
                            <template v-if="filtro_lista_medicos && filtro_lista_medicos.length">
                                <az-input
                                    type="label"
                                    icon="fas fa-user-md fa-fw"
                                    placeholder="Lista Selecionada"
                                    label="Lista Selecionada"
                                    value="Lista Selecionada">
                                    <template v-slot:buttonposb>
                                    <div class="input-group-append" v-if="!filtro.id_medico">
                                        <span class="input-group-text" id="basic-addon2" v-if="filtro_lista_medicos && filtro_lista_medicos.length">
                                            {{ filtro_lista_medicos.length }}
                                        </span>
                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Selecionar Profissionais" @click="selecionar_medicos()">
                                            <i class="fa-solid fa-list-check"></i>
                                        </button>
                                    </div>
                                    </template>
                                </az-input>
                            </template>

                            <template v-else>
                                <az-input
                                    placeholder="Todos os Profissionais..."
                                    icon="fas fa-user-md fa-fw"
                                    type="select"
                                    optionsMode="aql"
                                    service="medicos.index"
                                    optionsName="medicos-cadastro-meu"
                                    :optionsParm="{ ativos: true, meuop: true }"
                                    optionsData="id_pessoa"
                                    v-model="filtro.id_medico">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Selecionar Profissionais" @click="selecionar_medicos()">
                                                <i class="fa-solid fa-list-check"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </template>
                        </template>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            type2="( filas && filas.length <= 2 ) ? 'button-group' : 'select'"
                            type="select"
                            :optionsList="filas.map(item => { return { id: item.id_fila_laudo, search: item.search } })"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtro.id_fila_laudo"
                            :edicao="!$store.state.loading"
                            @input="refresh()"> 
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-primary" title="Adicionar Filtros." @click="incluir_filtro()">
                                        <i class="fa-solid fa-filter"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <div class="text-right mb-3" v-if="fila && fila.fl_anat_pat && !is_fila_outros">
            <button type="button" class="btn btn-outline-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Leitura de Amostras" @click="leitura_de_amostras_ap()">
                <i class="fa-solid fa-barcode fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Gerar Etiquetas" @click="gerar_etiquetas_ap()" v-if="false && ( $store.state.user.id_usuario == 1 )">
                <i class="fa-solid fa-rectangle-history-circle-plus"></i>
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Imprimir Etiquetas" @click="imprimir_etiquetas_ap()">
                <i class="fa fa-tags fa-fw" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Imprimir Laudos" @click="imprimir_laudos_ap()"
                :disabled="!( lista && lista.length )">
                <i class="fa fa-print" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Definir Responsável" @click="$refs.resp.abrir_lista(lista)"
                :disabled="!( lista && lista.length )">
                <i class="fa-solid fa-user-check fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Próxima Etapa" @click="abrirLaudo()"
                :disabled="!( lista && lista.length )">
                <i class="fa-solid fa-forward-step fa-fw"></i>
            </button>

            <button type="button" class="btn btn-outline-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Sinalizadores" @click="editar_sinalizador_lote()"
                :disabled="!( lista && lista.length )">
                <i class="fa-solid fa-ellipsis fa-fw"></i>
            </button>

            <button type="button" class="btn btn-outline-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Ocorrências" @click="registrar_ocorrencias_lote()" :disabled="!( lista && lista.length )">
                <i class="fa-solid fa-comments fa-fw"></i>
            </button>

            <button type="button" class="btn btn-sm ml-1" :class="( filtro.urgentes == 'N' ) ? 'btn-primary' : ( filtro.urgentes == 'S' ? 'btn-danger' : 'btn-outline-secondary')" data-toggle="tooltip" data-placement="top" title="Filtrar Urgentes" @click="toggle_busca_urgentes()">
                <i class="fa-solid fa-circle fa-fw" v-if="filtro.urgentes == 'N'"></i>
                <i class="fa-solid fa-circle-exclamation fa-fw" v-else></i>
            </button>

            <button type="button" class="btn btn-sm ml-1" :class="filtro.assinados == 'N' ? 'btn-danger' : ( filtro.assinados == 'S' ? 'btn-success' : 'btn-outline-secondary' )" data-toggle="tooltip" data-placement="top" title="Buscar Assinados" @click="toggle_busca_assinados()">
                <i class="fa-solid fa-pen-slash fa-fw" v-if="filtro.assinados == 'N'"></i>
                <i class="fa-solid fa-signature fa-fw" v-else></i>
            </button>
        </div>
        
        <card-tarefas :tarefas="tarefas" />

        <az-empty-state v-if="!lista || !lista.length"
            :icon="firstLoad ? 'fas fa-notes-medical' : 'fas fa-sync-alt'"
            :msg="firstLoad ? 'Nenhuma item encontrado.' : 'Clique no ícone para realizar a busca.'"
            :action="firstLoad ? '' : 'Buscar'"
            :method="load"></az-empty-state>

        <!-- Lista de agendas -->
        <div class="mt-3" id="lista-de-trabalho" v-else>

            <cabecalho-generico titulo="Lista de Trabalho">
            </cabecalho-generico>

            <!-- Fila de Outros Atendimentos -->
            <template v-if="is_fila_outros">
                <div v-for="(itens, grupo, igx) in lista_agrupada" :key="igx">

                    <h5 v-if="grupo">{{ grupo }}</h5>

                    <div class="mb-3 mx-3">
                        <div class="row my-2 py-1 dashcard w3-animate-opacity bg-white" v-for="(item, index) in itens"
                            :key="index"
                            >
                            <!-- Ação -->
                            <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                                <div class="d-flex flex-column">
                                    <button class="btn btn-sm" :class="'btn-' + ( item.status_laudo ? item.status_laudo.st_color : 'light' )"
                                        @click="abrirLaudo(item)">
                                        {{ item.status_laudo ? item.status_laudo.search : '?' }}
                                    </button>
                                </div>
                            </div>
                            <!-- Data -->
                            <div class="col col-12 col-md-2">
                                <div>{{ $util.getFormatDate(item.dt_inicio) }} {{ item.dt_inicio.substr(11,5) }}</div>
                                <div>#{{ item.id_atendimento }}</div>
                            </div>

                            <!-- Identificação do Paciente -->
                            <div class="col col-12 col-md-4" v-if="item.paciente">
                                <div v-if="item.status_contato && item.status_contato.contato_status">
                                    {{ item.status_contato.contato_status.search }}
                                </div>
                                <celula-dados-paciente :hor="{ marcacao: {
                                        plano: item.atendimento.plano,
                                        paciente: item.paciente,
                                    }
                                }" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <div v-if="item.recepcao">
                                    <i class="fa fa-building fa-fw mr-2" aria-hidden="true"></i>
                                    {{ item.recepcao.st_nome }}
                                </div>

                                <!-- Médico -->
                                <div v-if="item.atendimento_procedimento && item.atendimento_procedimento.medico">
                                    <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                    {{ item.atendimento_procedimento.medico.st_nome_exibicao }}
                                </div>
                                <div v-else-if="item.medico">
                                    <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                    {{ item.medico.st_nome_exibicao }}
                                </div>

                                <small>{{ item.st_observacoes }}</small>
                            </div>
                        </div>
                    </div>

                </div>

            </template>

            <!-- Fila de Laudos -->
            <template v-else>

                <div v-for="(itens, grupo, igx) in lista_agrupada" :key="igx">

                    <h5 v-if="grupo">{{ grupo }}</h5>

                    <div class="mb-3 mx-3">
                        <div v-for="(item, chave, index) in agrupar_lab(itens)" :key="index" class="my-2">
                            <div class="row py-1 dashcard align-items-center w3-animate-opacity bg-white">
                                <!-- Ação -->
                                <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                                    <div class="d-flex flex-column">
                                        <template v-if="is_lab_lista(item)">
                                            <a class="btn btn-primary" href="#" @click.prevent="liberar_laudo(item[0].atendimento_procedimento, item[0])">
                                                Resultados
                                            </a>
                                        </template>
                                        <template v-else>
                                            <button class="btn btn-sm" :class="'btn-' + ( item[0].status_laudo ? item[0].status_laudo.st_color : 'light' )"
                                                @click="abrirLaudo(item[0])">
                                                {{ item[0].status_laudo ? item[0].status_laudo.search : '?' }}
                                            </button>
                                            <div class="small text-muted" v-if="item[0].status_laudo && item[0].status_laudo.fl_pronto && item[0].laudo_entregas && item[0].laudo_entregas.length">
                                                Entregue
                                            </div>
                                            <div v-if="!item[0].atendimento_procedimento.fl_ativo" class="small text-danger">
                                                Atendimento Cancelado
                                            </div>
                                        </template>
                                    </div>
                                    <div class="small text-muted" title="Responsável">
                                        <a href="#" @click.prevent="$refs.resp.abrir(item[0])" class="card-link">{{ lista_resps(item[0]) }}</a>
                                    </div>
                                </div>
                                <!-- Data -->
                                <div class="col col-12 col-md-2">
                                    <div>
                                        <a href="#" @click.prevent="editar_marcacao(item[0].atendimento_procedimento.atendimento.marcacao)" title="Editar Atendimento.">
                                            <i class="fa fa-circle text-secondary mr-2" aria-hidden="true"></i>    
                                        </a>
                                        <a href="#" @click.prevent="ver_tempos(item[0])" class="card-link">
                                            {{ $util.getFormatDate(item[0].dt_inclusao) }} {{ item[0].dt_inclusao.substr(11,5) }}
                                        </a>
                                    </div>
                                    <div>
                                        <span title="Número do Atendimento">
                                            <a href="#" @click.prevent="ver_informacoes(item[0])" class="card-link">
                                                #{{ item[0].atendimento_procedimento.id_atendimento }}
                                            </a>
                                            <span class="badge badge-secondary" v-if="item[0].atendimento_procedimento.atendimento.marcacao && item[0].atendimento_procedimento.atendimento.marcacao.recepcao && item[0].atendimento_procedimento.atendimento.marcacao.recepcao.st_sigla" title="Recepção">
                                                {{ item[0].atendimento_procedimento.atendimento.marcacao.recepcao.st_sigla }}
                                            </span>
                                            <i class="fa-solid fa-signature text-success mx-1" v-if="item[0].doc_certificado" title="Assinado com Certificado Digital"></i>
                                            <i class="fas fa-x-ray ml-2" 
                                                :class="item[0].st_estudo_andamento  ? 'text-success' : (item[0].atendimento_procedimento && item[0].atendimento_procedimento.st_pacs == 'OK' ? 'text-dark' : '')"
                                                v-if="item[0].st_estudo_andamento || (item[0].atendimento_procedimento && item[0].atendimento_procedimento.st_pacs == 'OK')" data-toggle="tooltip" data-placement="top"
                                                @click="open_url_estudo(item[0])" style="cursor: pointer;"
                                                :title="item[0].st_estudo_andamento  ? 'Estudo iniciado' : (item[0].atendimento_procedimento && item[0].atendimento_procedimento.st_pacs == 'OK' ? 'Integrado com o Pacs' : '') "></i>
                                        </span>
                                        <span title="Horário Agendado" v-if="item[0].atendimento_procedimento.atendimento.marcacao && !item[0].atendimento_procedimento.atendimento.marcacao.fl_adicao_direta">
                                            <i class="far fa-calendar-alt ml-3 mr-1"></i>
                                            <span>{{ item[0].atendimento_procedimento.atendimento.marcacao.dt_inicio.substr(11,5) }}</span>
                                        </span>

                                        <span class="ml-2">
                                            <a href="#" @click.prevent="editar_sinalizador(item[0], item[0].atendimento_procedimento.atendimento.marcacao)" title="Editar Sinalizadores">
                                                <i class="ml-1" 
                                                    v-for="(sinal, isx) in item[0].sinals" :key="isx"
                                                    :class="( sinal.sinalizador.st_icon ? sinal.sinalizador.st_icon : 'fas fa-flag' ) + ' text-' + sinal.sinalizador.st_cor"
                                                    data-toggle2="tooltip" data-placement="top" 
                                                    :title="sinal.sinalizador.search"></i>
                                            
                                                <i class="ml-1" 
                                                    :class="( item[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.st_icon ? item[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.st_icon : 'fas fa-flag' ) + ' text-' + item[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.st_cor"
                                                    data-toggle2="tooltip" data-placement="top" 
                                                    :title="item[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.search" 
                                                    v-if="item[0].atendimento_procedimento.atendimento.marcacao && item[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento"></i>
                                            </a>
                                        </span>
                                    </div>
                                </div>
                                <!-- Identificação do Paciente -->
                                <div class="col col-12 col-md-4" v-if="item[0].atendimento_procedimento.atendimento.paciente">
                                    <celula-dados-paciente :hor="dados_paciente(item[0])" />

                                    <div v-if="item[0].status_contato && item[0].status_contato.contato_status" class="badge" :class="'badge-' + item[0].status_contato.contato_status.st_color">
                                        {{ item[0].status_contato.contato_status.search }}
                                    </div>
                                </div>

                                <div class="col col-12 col-md-4 d-flex justify-content-between">
                                    <div>
                                        <template v-if="!is_lab_lista(item)">
                                            <celula-dados-procedimento :hor="dados_procedimento(item[0])" @abriranexos="abrir_anexar_arquivo(item[0])" @abrirpreatend="abrir_pre_atend_lista" />
                                            <div class="small" v-if="item[0].atendimento_procedimento.st_obs">
                                                {{ item[0].atendimento_procedimento.st_obs }}
                                            </div>
                                            <div>
                                                <span class="badge" :class="'badge-' + cor_prazo(item[0])" v-if="item[0].atendimento_procedimento.dt_entrega" title="Prazo de Entrega">
                                                    P: {{ $util.getFormatDate(item[0].atendimento_procedimento.dt_entrega) }}
                                                </span>
                                                <i class="fa-solid fa-circle-exclamation text-danger ml-1" v-if="item[0].atendimento_procedimento.fl_urgente" title="Urgente"></i>
                                                <span v-if="item[0].atendimento_procedimento.amostra" class="small text-muted ml-2">
                                                    {{ item[0].atendimento_procedimento.amostra.search }}
                                                </span>

                                                <template v-if="item[0].js_classes">
                                                    <span v-for="(classe, icx) in item[0].js_classes" :key="icx" class="badge badge-success ml-1">
                                                        {{ classe }}
                                                    </span>
                                                </template>
                                            </div>
                                            <grupo-etq-amostras :atp="item[0].atendimento_procedimento" />
                                        </template>
                                        <div v-else>
                                            <a href="#" @click.prevent="imprimir_laudo(exame)" v-for="(exame, iix) in item" :key="iix">
                                                <span class="badge mr-1" :class="'badge-' + ( exame.status_laudo ? exame.status_laudo.st_color : 'secondary' )"
                                                    data-toggle2="tooltip" data-placement="top" :title="exame.status_laudo.search">
                                                    {{ sigla(exame) }}
                                                </span>
                                            </a>
                                        </div>
                                    </div>

                                    <!-- Menu de opções -->
                                    <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                        <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <button class="dropdown-item" :disabled="!item[0].atendimento_procedimento.atendimento.marcacao"
                                                @click="abrir_pre_atendimento(item[0])">
                                                Pré-Atendimento
                                                <span class="badge badge-secondary" v-if="item[0].atendimento_procedimento.atendimento.marcacao.doc_pre_atends && item[0].atendimento_procedimento.atendimento.marcacao.doc_pre_atends.length">
                                                    {{ item[0].atendimento_procedimento.atendimento.marcacao.doc_pre_atends.length }}
                                                </span>
                                            </button>
                                            <button class="dropdown-item" @click="ver_informacoes(item[0])">
                                                Informações
                                            </button>
                                            <button class="dropdown-item" @click="alterar_procedimento(item[0].atendimento_procedimento)" v-if="fila && fila.fl_permitir_alterar_medico" :disabled="item[0].status_laudo && item[0].status_laudo.fl_pronto">
                                                Alterar Procedimento
                                            </button>
                                            <button class="dropdown-item" @click="alterar_medico(item[0].atendimento_procedimento.atendimento.marcacao, item[0])" v-if="fila && fila.fl_permitir_alterar_medico">
                                                Alterar Profissional
                                            </button>
                                            <button class="dropdown-item" @click="alterar_data_exame(item[0])" :disabled="item[0].status_laudo && item[0].status_laudo.fl_pronto">
                                                Alterar Data do Exame
                                            </button>
                                            <button class="dropdown-item" @click="alterar_data_entrega([item[0]])" :disabled="item[0].status_laudo && item[0].status_laudo.fl_pronto">
                                                Alterar Data de Entrega
                                            </button>
                                            <button class="dropdown-item" @click="alterar_data_entrega(lista)">
                                                Alterar Datas de Entrega
                                            </button>
                                            <button class="dropdown-item" @click="$refs.resp.abrir(item[0])">
                                                Definir Responsável
                                            </button>
                                            <button class="dropdown-item" @click="abrir_contatos(item[0])">
                                                Ocorrências
                                            </button>

                                            <!-- Impressão -->
                                            <button class="dropdown-item" @click="imprimir_laudo_lab(item[0].atendimento_procedimento.id_atendimento)" v-if="item.length > 1">
                                                Imprimir
                                            </button>
                                            <button class="dropdown-item" @click="imprimir_laudo(item[0])" :disabled="!item[0].status_laudo || !item[0].status_laudo.fl_pronto" v-else>
                                                Imprimir
                                            </button>

                                            <button class="dropdown-item" @click="entregar(item[0])" :disabled="!item[0].status_laudo || !item[0].status_laudo.fl_pronto">
                                                Registrar Entrega de Resultado
                                            </button>
                                            <button class="dropdown-item" @click="abrirLaudo(item[0], true)" v-if="item.length <= 1">
                                                Edição Laudo
                                            </button>
                                            <button class="dropdown-item" @click="open_url_estudo(item[0])" v-if="item.length <= 1 && pode_abrir_pacs(item[0])">
                                                Visualizar Imagens do PACS
                                            </button>
                                            <button class="dropdown-item" @click="consultarImagensChave(item[0])" v-if="item.length <= 1 && pode_abrir_pacs(item[0])">
                                                Consultar Imagens Chave do PACS
                                            </button>
                                            <button class="dropdown-item" @click="compartilhar(item[0])" v-if="item.length == 1">
                                                Compartilhar Laudo
                                            </button>
                                            <button class="dropdown-item" @click="log_laudo(item[0])">
                                                Log
                                            </button>
                                            <template v-if="tem_amostra(item)">
                                                <div class="dropdown-divider"></div>
                                                <button class="dropdown-item" @click="$refs.amostras.abrir(item[0].atendimento_procedimento.atendimento.marcacao.id_atendimento)">Amostras</button>
                                                <button class="dropdown-item" @click="verificarResultadoExterno(item)">Verificar Resultado</button>
                                            </template>
                                            <template v-if="exibir_retorno(item)">
                                                <div class="dropdown-divider"></div>
                                                <button class="dropdown-item" @click="integrar_retorno(item)">Integrar Retorno</button>
                                            </template>

                                            <template v-if="item[0].atendimento_procedimento.atendimento.marcacao.js_outros_campos && item[0].atendimento_procedimento.atendimento.marcacao.js_outros_campos.id_aso_medsafe">
                                                <div class="dropdown-divider"></div>
                                                <button class="dropdown-item" @click="enviar_resultado_medsafe(item[0])">
                                                    Enviar Resultados MedSafe ({{ item[0].atendimento_procedimento.atendimento.marcacao.js_outros_campos.id_aso_medsafe }})
                                                </button>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <template v-if="item[0] && item[0].tarefa">
                                <div class="row p-0">
                                    <div class="col col-12 alert alert-secondary mb-0 py-1 px-3 small text-muted text-nowrap text-truncate">
                                        <i class="fa-solid fa-circle-check fa-fw text-success mr-2" v-if="item[0].tarefa.fl_feita"></i>
                                        <i class="fa-solid fa-circle-question fa-fw text-primary mr-2" v-else></i> 
                                        <span v-if="item[0].tarefa.contato">
                                            <span v-if="item[0].tarefa.contato.usuario && item[0].tarefa.contato.usuario.st_login" class="mr-2">
                                                {{ item[0].tarefa.contato.usuario && item[0].tarefa.contato.usuario.st_login }}:
                                            </span>
                                            {{ item[0].tarefa.contato.st_observacoes }}
                                        </span>
                                        <span v-else-if="item[0].tarefa.st_descricao">{{ item[0].tarefa.st_descricao }}</span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>

                </div>

            </template>
        </div>

        <az-wiki topic="Laudos" />

        <pre v-if="false" class="alert alert-warning">{{ lista_agrupada }}</pre>

        <!-- Modal -->
        <div class="modal fade" id="procedimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Ação
                            <span v-if="laudo && laudo.atendimento_procedimento">
                                #{{ laudo.atendimento_procedimento.id_atendimento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="laudo" class="card">
                            <div class="card-body">
                                <celula-dados-paciente :hor="dados_paciente(laudo)" />

                                <div v-if="laudo.atendimento_procedimento.atendimento.medico_solicitante">
                                    <hr>
                                    Solicitante: {{ laudo.atendimento_procedimento.atendimento.medico_solicitante.st_nome }}
                                    <div v-if="laudo.atendimento_procedimento.atendimento.medico_solicitante.conselho" class="small">
                                        {{ laudo.atendimento_procedimento.atendimento.medico_solicitante.conselho.st_sigla }}
                                        {{ laudo.atendimento_procedimento.atendimento.medico_solicitante.st_numero_conselho }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="laudo && laudo.fila_block" class="alert alert-danger">
                            <i class="fa-solid fa-triangle-exclamation mr-3"></i>
                            Aguardando: <strong>{{ laudo.fila_block.search }}</strong>
                        </div>

                        <div v-else>

                            <div v-if="status_selec">

                                <div class="list-group">
                                    
                                    <button type="button" class="list-group-item list-group-item-action active d-flex justify-content-between"
                                        :class="'list-group-item-' + status_selec.st_color" 
                                        @click="status_selec = null; status_modelo = null;">

                                        <span>{{ status_selec.st_acao }}</span>
                                        <div>
                                            <span class="badge badge-light" v-if="!laudo && selecionados && selecionados.length">{{ selecionados.length }}</span>
                                        </div>

                                    </button>

                                </div>

                                <template v-if="status_modelo && status_modelo.doc_pre_atend">

                                    <az-sub-title :title="status_modelo.st_modelo_prontuario" class="mt-3" />

                                    <formulario 
                                        :compact="status_modelo.doc_pre_atend.fl_compact"
                                        v-model="status_modelo.doc_pre_atend.js_conteudo" 
                                        :saved="false" 
                                        :validate="validate"
                                        mode="fixed"
                                        :config="true" />

                                </template>

                                <template v-if="status_selec.fl_info_resp && resps">
                                    <az-sub-title title="Responsáveis" class="mt-3" />
                                    <laudo-usuario-form :laudo="resps" :validate="validate" :status_selec="status_selec" />
                                </template>

                                <pre v-if="false">{{ status_modelo }}</pre>

                            </div>

                            <template v-else-if="laudo || ( lista && lista.length )">

                                <div class="list-group" v-if="fila">
                                    <button type="button" class="list-group-item list-group-item-action" :class="'list-group-item-' + status.st_color"
                                        v-for="(status, isx) in fila.lista_status" :key="isx"
                                        :disabled="$store.state.loading || !selecionados.length" 
                                        @click="laudo_status(status)">

                                        {{ status.st_acao }}

                                    </button>
                                </div>

                                <template v-if="!laudo && lista">
                                    <table class="table table-sm table-hover small mt-3 cabecalho-fixo-modal">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <a href="#" @click.prevent="toggle_selecionados(laudo)">
                                                        <i class="fa-solid fa-square"></i>
                                                    </a>
                                                </th>
                                                <th>
                                                    Paciente
                                                    <span class="badge badge-secondary ml-2">{{ selecionados.length }}</span>
                                                </th>
                                                <th>#</th>
                                                <th>Procedimento</th>
                                                <th>Material</th>
                                                <th>Solicitante</th>
                                                <th>Responsáveis</th>
                                                <th>
                                                    <grupo-etq-amostras :atp="cassetes_consolidados" color="dark" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, iix) in listar_laudos()" :key="iix" :class="!item.sel ? 'table-secondary' : ''">
                                                <td>
                                                    <input type="checkbox" v-model="item.sel" /> 
                                                </td>
                                                <td>
                                                    {{ item.atendimento_procedimento.atendimento.paciente.st_nome }}
                                                </td>
                                                <td>
                                                    #{{ item.atendimento_procedimento.id_atendimento }}
                                                </td>
                                                <td>
                                                    {{ item.atendimento_procedimento.procedimento.search }}
                                                </td>
                                                <td>
                                                    <span v-if="item.atendimento_procedimento.amostra">
                                                        {{ item.atendimento_procedimento.amostra.search }}
                                                        <template v-if="item.atendimento_procedimento.amostra.js_classes && item.atendimento_procedimento.amostra.js_classes.length == 1">
                                                            <span class="badge badge-success ml-1" v-for="(classe, icx) in item.atendimento_procedimento.amostra.js_classes" :key="icx">
                                                                {{ classe }}
                                                            </span>
                                                        </template>
                                                    </span>
                                                </td>
                                                <td style="max-width: 100px;">
                                                    <div class="text-truncate" v-if="item.atendimento_procedimento.atendimento && item.atendimento_procedimento.atendimento.medico_solicitante">
                                                        {{ item.atendimento_procedimento.atendimento.medico_solicitante.st_nome }}
                                                    </div>
                                                </td>
                                                <td>
                                                    {{ lista_resps(item) }}
                                                </td>
                                                <td>
                                                    <grupo-etq-amostras :atp="item.atendimento_procedimento" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>

                                <template v-else>
                                    <button type="button" class="btn btn-outline-primary btn-sm mt-3"
                                        v-if="lista && listar_laudos().length > 2" @click="toggle_selecionados(laudo)">
                                        Todos
                                    </button>
                                
                                    <ul class="list-group mt-3" v-if="lista">
                                        <li class="list-group-item" v-for="(ld, iix) in listar_laudos()" :key="iix">
                                            <input type="checkbox" class="mr-3" v-model="ld.sel" :disabled="laudo && ( ld.id_laudo == laudo.id_laudo )">
                                            <span v-if="ld">
                                                {{ ld.atendimento_procedimento.procedimento.search }}
                                            </span>
                                        </li>
                                    </ul>
                                </template>

                            </template>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit v-if="status_selec && ( status_selec.fl_info_resp || status_modelo )" @click="laudo_status(status_selec)">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <br><br><br><br><br>
        <br><br><br><br><br>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <!-- Informações do Exame para Colar no Aparelho -->
        <div class="modal fade" id="informacoesModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="informacoes">
                    <div class="modal-header">
                        <h5 class="modal-title">Informações</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            label="Paciente"
                            :edicao="false"
                            v-model="informacoes.atendimento_procedimento.atendimento.paciente.st_nome">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                        @click="copiar_clipboard(informacoes.atendimento_procedimento.atendimento.paciente.st_nome)">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            label="Id do Paciente"
                            :edicao="false"
                            v-model="informacoes.atendimento_procedimento.atendimento.id_paciente">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                        @click="copiar_clipboard(informacoes.atendimento_procedimento.atendimento.id_paciente)">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            label="Sexo"
                            :edicao="false"
                            v-model="informacoes.atendimento_procedimento.atendimento.paciente.cadastro.ch_sexo">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                        @click="copiar_clipboard(informacoes.atendimento_procedimento.atendimento.paciente.cadastro.ch_sexo)">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            label="Data de Nascimento"
                            :edicao="false"
                            :value="$util.getFormatDate(informacoes.atendimento_procedimento.atendimento.paciente.cadastro.dt_nascimento)">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                        @click="copiar_clipboard($util.getFormatDate(informacoes.atendimento_procedimento.atendimento.paciente.cadastro.dt_nascimento))">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            label="Id do Atendimento"
                            :edicao="false"
                            v-model="informacoes.atendimento_procedimento.atendimento.id_atendimento">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                        @click="copiar_clipboard(informacoes.atendimento_procedimento.atendimento.id_atendimento)">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            label="Procedimento"
                            :edicao="false"
                            v-model="informacoes.atendimento_procedimento.procedimento.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                        @click="copiar_clipboard(informacoes.atendimento_procedimento.procedimento.search)">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            v-if="informacoes.atendimento_procedimento.st_an"
                            label="Accession Number"
                            :edicao="false"
                            v-model="informacoes.atendimento_procedimento.st_an">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                        @click="copiar_clipboard(informacoes.atendimento_procedimento.st_an)">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            v-if="informacoes.atendimento_procedimento.atendimento && informacoes.atendimento_procedimento.atendimento.medico_solicitante"
                            label="Solicitante"
                            :edicao="false"
                            v-model="informacoes.atendimento_procedimento.atendimento.medico_solicitante.st_nome">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                        @click="copiar_clipboard(informacoes.atendimento_procedimento.atendimento.medico_solicitante.st_nome)">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <div v-if="informacoes.atendimento_procedimento.st_pacs == 'OK' || informacoes.atendimento_procedimento.st_an ">
                            <pacs-status 
                                class="mt-3" 
                                ref="pacsStatus" 
                                :atendimento="informacoes.atendimento_procedimento.atendimento"
                                :procs="[informacoes.atendimento_procedimento]" />
                        </div>

                        <pre v-if="false">{{ informacoes }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Pré Atendimento -->
        <documento-pre-atendimento ref="doc_pre_atend" @refresh="load(false)" />

        <!-- Alterar Profissional -->
        <alterar-profissional ref="alterar_prof" :pode_por_medico="true" @refresh="load(false)" />

        <!-- Alterar Procedimento -->
        <alterar-procedimento ref="alterar_proc" @refresh="load(false)" />

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar">
            <az-file-upload
            ref="upload"
            @refresh="carregar_arquivos()"
            :multiple="true"
            :arquivos="marcacao.arquivos"
            :parms="{ model_type: 'marcacao', model_id: marcacao.id_marcacao }" />
        </template>

        <!-- Registrar Entrega de Resultado -->
        <registrar-entrega ref="entrega" @refresh="load()" />

        <!-- Liberação de Laudo -->
        <liberacao-laudo ref="liberacao" :fila="fila" @refresh="load()" />

        <!-- Amostras -->
        <amostras ref="amostras" />

        <!-- Alterar Prazo de Entrega -->
        <laudos-prazo-entrega ref="prazo_entrega" @refresh="load()" />

        <!-- Compartilhar Laudo -->
        <compartilhar-laudo ref="compartilhar" @refresh="load()" />

        <!-- Seleção de Médicos -->
        <selecao-medico-lista ref="selmed" @selecionados="filtrar_selecao_medicos" />

        <!-- Tempos de Marcação -->
        <tempos-marcacao ref="tempos" />

        <!-- Registrar Contatos -->
        <registrar-contatos 
            titulo="Laudo"
            :lista_status="lista_status ? lista_status.filter(item => item.id_contato_status != 'R') : []" 
            ref="regcontatos" 
            @refresh="load()"></registrar-contatos>

        <!-- Amostras de Anatomia Patológica -->
        <ler-amostras-a-p ref="amoap" :fila="fila" />

        <!-- Laudo Usuário Responsável -->
        <laudo-usuario ref="resp" @refresh="load()" />

        <!-- Filtros Adicionais -->
        <crm-filtros ref="filtros" @refresh="load()" model_type="App\azure\laudo" />

        <!-- Imprimir Etiquetas -->
        <imprimir-etiquetas-lote-a-p ref="imprimir_etq_ap" />

        <!-- Imprimir Laudos -->
        <laudo-imprimir-laudos ref="imprimir_laudos" />

        <!-- Edição de Sinalizador -->
        <laudo-editar-sinalizador ref="editar_sinalizador" @refresh="load()" />

        <!-- Edição de Sinalizador -->
        <laudo-editar-sinalizador-lote ref="editar_sinalizador_lote" @refresh="load()" />

        <!-- Alterar Data do Laudo -->
        <alterar-data-laudo ref="alterar_data_laudo" @refresh="load()" />

        <!-- Ocorrência de Laudo em Lote -->
        <laudo-ocorrencia-lote ref="ocorrencia_lote" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';
import $ from 'jquery';
import SubMenuLaudos from './SubMenuLaudos.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import TemposMarcacao from '../../shared/TemposMarcacao.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzWiki from '../../util/AzWiki.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import RelatoriosLinkados from '../../relatorios/shared/RelatoriosLinkados.vue';
import RegistrarEntrega from '../recepcao/RegistrarEntrega.vue';
import DocumentoPreAtendimento from '../../shared/DocumentoPreAtendimento.vue';

import AlterarProfissional from '../recepcao/AlterarProfissional.vue';
import AlterarProcedimento from '../recepcao/AlterarProcedimento.vue';

import AzFileUpload from '../../util/AzFileUpload.vue';
import { subscribe } from "../../../service/Notify";

import LiberacaoLaudo from '../laboratorio/LiberacaoLaudo.vue';
import Amostras from '../laboratorio/Amostras.vue';

import LaudosPrazoEntrega from './LaudosPrazoEntrega.vue';

import CardTarefas from '../../shared/tarefa/CardTarefas.vue';
import CompartilharLaudo from './CompartilharLaudo.vue';

import PacsStatus from "../../shared/PacsStatus.vue";
import SelecaoMedicoLista from '../callcenter/SelecaoMedicoLista.vue';

import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import LerAmostrasAP from './LerAmostrasAP.vue';

import LaudoUsuario from './LaudoUsuario.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Formulario from '../consultorio/Formulario.vue';
import AzSubmit from '../../util/AzSubmit.vue';

import CrmFiltros from '../crm/CrmFiltros.vue';
import GrupoEtqAmostras from './GrupoEtqAmostras.vue';

import LaudoUsuarioForm from './LaudoUsuarioForm.vue';

import ImprimirEtiquetasLoteAP from './ImprimirEtiquetasLoteAP.vue';
import LaudoImprimirLaudos from './LaudoImprimirLaudos.vue';
import LaudoEditarSinalizador from './LaudoEditarSinalizador.vue';

import LaudoEditarSinalizadorLote from './LaudoEditarSinalizadorLote.vue';
import AlterarDataLaudo from './AlterarDataLaudo.vue';

import LaudoOcorrenciaLote from './LaudoOcorrenciaLote.vue';

export default {
    data () {
        return {
            dados: null,
            from: moment().subtract(7, "days").format('YYYY-MM-DD'),
            to: this.$util.hoje(),
            filtro: {
                id_fila_laudo: this.$util.getCookie('laudo-fila'),
                id_status_laudo: "",
                id_unidade_operacao: this.$util.getCookie('unidade-fila-laudo'),
                id_recepcao: this.$util.getCookie('recepcao-fila-laudo'),
                id_medico: ( !this.$store.state.user.medico && this.$store.state.contexto && this.$store.state.contexto.fila_id_medico )
                    ? this.$store.state.contexto.fila_id_medico
                    : '',
                inicio: "",
                fim: "",
                periodo: "do",
                tipo_data: "", 
                tipo_ordem: "DE", 
                ordem_dir: 'D', 
                block_prontos: false, 
                urgentes: false, 
                assinados: false, 
            },
            filas: [],
            search: "",
            paciente: "",
            laudo: null,
            page: 1,
            canceltoken: null,
            tem_paginacao: false,
            search_timeout: null,
            acao_anexar: false,
            meus: false,
            firstLoad: false,
            buscar_ao_abrir: false,
            refresher: null,
            informacoes: null,
            agrupar_por_status: false, 
            tarefas: null, 
            montando: true, 
            filtro_lista_medicos: [], 
            primeiro_refresh: false, 
            edicao_contato: null, 
            lista_status: [], 
            status_selec: null, 
            status_modelo: null, 
            validate: false, 
            resps: null, 
            lista_selecao: [], 
        }
    },
    components: {
        AzInput,
        AzEmptyState,
        SubMenuLaudos,
        CelulaDadosPaciente,
        CelulaDadosProcedimento,
        TemposMarcacao, 
        AzPeriodo,
        AlterarProfissional,
        AlterarProcedimento, 
        AzWiki,
        PrintExport,
        CabecalhoGenerico,
        AzFileUpload,
        RelatoriosLinkados,
        RegistrarEntrega,
        DocumentoPreAtendimento,
        LiberacaoLaudo,
        Amostras, 
        LaudosPrazoEntrega,
        CardTarefas,
        CompartilharLaudo, 
        PacsStatus,
        SelecaoMedicoLista, 
        RegistrarContatos, 
        LerAmostrasAP, 
        LaudoUsuario, 
        AzSubTitle,
        Formulario, 
        AzSubmit, 
        CrmFiltros, 
        GrupoEtqAmostras, 
        LaudoUsuarioForm, 
        ImprimirEtiquetasLoteAP, 
        LaudoImprimirLaudos, 
        AlterarDataLaudo,
        LaudoEditarSinalizador, 
        LaudoEditarSinalizadorLote, 
        LaudoOcorrenciaLote, 
    },

    computed: {
        lista_agrupada: function() {
            let lista = _.groupBy(
                _.orderBy(
                    this.lista.map(item => {
                            if ( this.is_lab(item) ) { 

                                item.quebra = 'Laboratório';
                                item.lab = true;
                                item.ordem = 0;

                            } else { 

                                item.quebra = (
                                        (
                                            item.status_laudo && item.status_laudo.fl_pronto 
                                        )
                                        || (
                                            this.fila
                                            && this.fila.fl_fila_procedimento
                                            && item.status_laudo
                                            && item.status_laudo.st_acao_especial == 'F'
                                        )
                                    )
                                    ? 'Pronto' : '';

                                item.ordem = item.quebra;

                                if ( this.agrupar_por_status && item.status_laudo ) { 
                                    item.quebra = item.status_laudo.st_status_laudo;
                                    item.ordem = item.status_laudo.in_regra_ordem ? item.status_laudo.in_regra_ordem : 99999;
                                }

                            }

                            return item;
                        }), 'ordem'),
                'quebra'
            );

            return lista;
        },

        lista: function () {
            if ( !this.dados || !this.dados.data )
                return [];

            if ( this.search && this.search.substr(0,1) == '#' && !isNaN(this.search.substr(1)) ) {
                return this.dados.data.filter(item => item.atendimento_procedimento && item.atendimento_procedimento.id_atendimento == this.search.substr(1));
            }

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            let lista = this.dados.data.filter(item => !this.filtro.id_status_laudo || item.id_status_laudo == this.filtro.id_status_laudo)
                .filter (item => ( !this.search || reg.test(JSON.stringify(item)) ));

            if ( this.filtro.tipo_ordem ) { 
                return lista;
            }

            return _.orderBy(
                lista,
                item => _.get(item, 'atendimento_procedimento.atendimento.marcacao.dt_inicio')
            );
        },

        selecionados: function () {
            if ( !this.lista || !this.lista.length )
                return [];

            return this.listar_laudos().filter(item => item.sel);
        },

        cassetes_consolidados: function () {
            return { 
                grupo_etq_amostras: _.values(
                    this.selecionados.reduce((acc, item) => {
                        if ( item.atendimento_procedimento && item.atendimento_procedimento.grupo_etq_amostras && item.atendimento_procedimento.grupo_etq_amostras.length ) { 
                            item.atendimento_procedimento.grupo_etq_amostras.forEach(ge => {
                                if ( !_.get(acc, _.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')) ) { 
                                    acc[_.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')] = _.cloneDeep(ge);
                                } else if ( ge.qt_itens ) { 
                                    acc[_.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')].qt_itens = acc[_.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')].qt_itens + ge.qt_itens;
                                }
                            });
                        }
                        return acc;
                    }, {})
                )
            };
        },

        fila: function () {
            if ( !this.filtro.id_fila_laudo )
                return null;

            return this.filas.find(item => item.id_fila_laudo == this.filtro.id_fila_laudo);
        },

        is_fila_outros: function () {
            return ( this.fila && this.fila.fl_fila_procedimento && this.fila.receps_count ) ? true : false;
        },

    },

    methods: {
        registrar_ocorrencias_lote () { 
            this.$refs.ocorrencia_lote.abrir_lista(this.selecionados);
        },

        alterar_data_exame (laudo) { 
            this.$refs.alterar_data_laudo.abrir(laudo);
        },

        alterar_procedimento (atp) { 
            this.$refs.alterar_proc.abrir_atp(atp, atp.atendimento);
        },

        toggle_busca_urgentes () { 
            if ( !this.filtro.urgentes ) { 
                this.filtro.urgentes = 'S';
            } else if ( this.filtro.urgentes == 'S' ) { 
                this.filtro.urgentes = 'N';
            } else { 
                this.filtro.urgentes = false;
            }

            this.load(); 
        },

        toggle_busca_assinados () { 
            if ( !this.filtro.assinados ) { 
                this.filtro.assinados = 'S';
            } else if ( this.filtro.assinados == 'S' ) { 
                this.filtro.assinados = 'N';
            } else { 
                this.filtro.assinados = false;
            }

            this.load(); 
        },

        editar_sinalizador (laudo, marcacao) { 
            this.$refs.editar_sinalizador.abrir(laudo, marcacao);
        },

        editar_sinalizador_lote () { 
            this.$refs.editar_sinalizador_lote.abrir(this.selecionados);
        },

        imprimir_etiquetas_ap () { 
            this.$refs.imprimir_etq_ap.abrir(this.listar_laudos());
        },

        imprimir_laudos_ap () { 
            this.$refs.imprimir_laudos.abrir(this.listar_laudos());
        },

        incluir_filtro () { 
            this.$refs.filtros.abrir(0); 
        },

        leitura_de_amostras_ap () { 
            this.$refs.amoap.abrir(); 
        },

        lista_resps (laudo) { 
            let lista = [];

            if ( laudo && laudo.resps && laudo.resps.length ) { 
                lista = laudo.resps.filter(item => item.fl_ativo)
                    .map(item => item.usuario ? item.usuario.st_login : '---' );
            }

            return lista.join(', ');
        },

        ver_tempos (laudo) { 
            let base = _.cloneDeep(laudo);
            let marcacao = base.atendimento_procedimento.atendimento.marcacao;

            if ( marcacao ) { 
                marcacao.procedimento = base.atendimento_procedimento.procedimento;
                marcacao.medico = base.atendimento_procedimento.atendimento.medico;
                marcacao.timeline = null; 

                let atendimento = _.cloneDeep(base.atendimento_procedimento.atendimento);
                atendimento.marcacao = null;
                marcacao.atendimento = atendimento;
            }
            
            this.$refs.tempos.abrir(marcacao);
        },

        enviar_resultado_medsafe (laudo) { 
            this.$util.atualizar(this, {
                service: 'laudos',
                func: 'enviar_resultado_medsafe',
                dados: {
                    id_marcacao: laudo.atendimento_procedimento.atendimento.marcacao.id_marcacao,
                },
                toast: true, 
                msg: 'Envio Disparado',
            });
        },

        abrir_contatos (laudo) { 
            this.$util.load(this, { 
                service: 'laudos',
                func: 'laudo',
                parms: { 
                    id_laudo: laudo.id_laudo, 
                    contatos: true, 
                },
                loadTo: res => { 
                    this.edicao_contato = res;
                    this.lista_status = res.lista_status ? res.lista_status : []; 

                    this.edicao_contato.model = { 
                        type: 'laudo',
                        id: laudo.id_laudo,
                    };

                    this.$refs.regcontatos.editar(this.edicao_contato);
                }
            });
        },

        refresh () { 
            if ( !this.montando && this.firstLoad ) { 
                this.load();
            }
        },

        filtrar_selecao_medicos (lista_selec) { 
            let lista = lista_selec.map(item => item.id_pessoa);

            if ( lista.length == 1 ) { 
                this.filtro_lista_medicos = [];
                this.filtro.id_medico = lista[0];  
            } else { 
                this.filtro.id_medico = "";
                this.filtro_lista_medicos = lista;
            }

            this.load(false);
        },

        selecionar_medicos () { 
            $('[data-toggle="tooltip"]').tooltip("dispose");
            this.$refs.selmed.abrir_carregando({ ativos: true, atendimento: true }, this.filtro_lista_medicos);
        },

        compartilhar (laudo) { 
            this.$refs.compartilhar.abrir(laudo);
        },

        cor_prazo (laudo) { 
            if ( laudo && laudo.status_laudo && laudo.status_laudo.fl_pronto ) {
                return 'success';
            }

            if ( laudo && laudo.atendimento_procedimento && laudo.atendimento_procedimento.dt_entrega ) { 
                let prazo = laudo.atendimento_procedimento.dt_entrega;

                if ( prazo ) { 

                    prazo = prazo.slice(0,10);
                    
                    if ( prazo < this.$util.hoje() ) { 
                        return 'danger';
                    } else if ( prazo == this.$util.hoje() ) { 
                        return 'warning';
                    } else { 
                        return 'primary';
                    }

                }
            } 

            return '';
        },

        pode_abrir_pacs: function(item) {
            return item && item.atendimento_procedimento && item.atendimento_procedimento.st_pacs == 'OK';
        },

        open_url_estudo(item) {
            this.$util.atualizar(this, {
                service: 'pep',
                func: 'dr_tis_url',
                redir_api: true,
                dados: {
                    id_atendimento_procedimento: item.atendimento_procedimento.id_atendimento_procedimento,
                    id_paciente: item.atendimento_procedimento.atendimento.id_paciente,
                    is_host_public: (this.$util.getCookie('cn-hpvip') == 'S')
                },
                callback: (res) => {
                    if(res && res.url) {
                        this.$root.$children[0].$refs.pacs_viewer.abrir(res);
                    }
                }
            });

        },

        alterar_data_entrega (lista) { 
            this.$refs.prazo_entrega.abrir(lista);
        },

        salvar_agrupar () { 
            if ( this.montando ) { 
                return;
            }

            this.$util.setCookie('ld-aps', this.agrupar_por_status ? 'S' : 'N');
            this.$util.setCookie('ld-op', this.filtro.block_prontos ? 'S' : 'N');
            this.$util.setCookie('ld-to', this.filtro.tipo_ordem);
            this.$util.setCookie('ld-od', this.filtro.ordem_dir);
        },

        exibir_retorno (item) { 
            if ( item && item.length ) { 
                if ( ( window.redir == 'teste' || window.redir == 'labs' ) 
                    && item[0].atendimento_procedimento.atendimento.marcacao.st_id_externo ) { 
                    return true;
                }
            }

            return false;
        },

        integrar_retorno (item) { 
            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'integrar_retorno',
                dados: { 
                    id_laudo: item[0].id_laudo,
                },
                toast: true, 
            });
        },

        editar_marcacao(marcacao) { 
            this.$root.editar_marcacao(marcacao.id_marcacao, () => { 
                this.load();
            });
        },

        is_lab_lista (item) { 
            return item.length > 0 
                && this.tem_amostra(item)
                && ( item[0].atendimento_procedimento.procedimento.id_especialidade == 2 
                || item[0].atendimento_procedimento.procedimento.id_especialidade == 67 );
        },

        verificarResultadoExterno(laudo) {
            this.$util.atualizar(this, {
                service: 'laudos',
                func: 'buscar_resultado_externo',
                dados: {
                    id_marcacao: laudo[0].atendimento_procedimento.atendimento.marcacao.id_marcacao,
                },
                toast: true,
                callback: () => { 
                    console.log('Recarregar...');
                    this.load();
                },
            });
        },

        tem_amostra (lista) { 
            return lista.find(laudo => laudo.atendimento_procedimento.amostra_atendimento_procedimento) ? true : false;
        },

        sigla(item) { 
            return item.atendimento_procedimento.procedimento.st_sigla 
                ? item.atendimento_procedimento.procedimento.st_sigla 
                : item.atendimento_procedimento.procedimento.st_procedimento;
        },

        agrupar_lab (lista) { 
            let ag_lista = _.groupBy(lista, (item) => {
                return this.is_lab(item) 
                    ? 'L' + item.atendimento_procedimento.id_atendimento 
                    : 'A' + item.atendimento_procedimento.id_atendimento_procedimento;
            });

            return ag_lista;
        },

        is_lab(item) { 
            return item.atendimento_procedimento.procedimento.id_especialidade == 2
                || item.atendimento_procedimento.procedimento.id_especialidade == 67;
        },

        liberar_laudo (atp, laudo) { 
            this.$refs.liberacao.abrir(atp.id_atendimento, this.dados_paciente(laudo));
        },

        log_laudo (item) {
            this.$util.logAudit('laudo', item.id_laudo);
        },

        abrir_pre_atend_lista(item) {
            this.$refs.doc_pre_atend.abrir(item);
        },

        abrir_pre_atendimento(item) {
            let marcacao = _.cloneDeep(item.atendimento_procedimento.atendimento.marcacao);

            marcacao.nome_paciente = item.atendimento_procedimento.atendimento.paciente.st_nome;
            marcacao.procedimento = item.atendimento_procedimento.procedimento;
            marcacao.medico = item.atendimento_procedimento.atendimento.medico;

            this.$refs.doc_pre_atend.abrir(marcacao)
        },

        copiar_clipboard (text) {
            if (!navigator.clipboard) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position="fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            } else {
                navigator.clipboard.writeText(text).then(function() {
                    console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Informação '" + text + "' copiada para a área de transferência.",
                life: 3000
            });
        },

        ver_informacoes(laudo) {
            this.informacoes = _.cloneDeep(laudo);

            $('#informacoesModal').modal('show');
        },

        toggle_selecionados(laudo) {
            let lista = this.listar_laudos();

            let opcao = lista.find(ld => ( !laudo || ld.id_laudo != laudo.id_laudo ) && !ld.sel);

            lista.forEach(ld => {
                if ( !laudo || ( ld.id_laudo != laudo.id_laudo ) ) {
                    ld.sel = opcao;
                }
            })
        },

        imprimir_laudo (laudo) {
            if ( laudo.status_laudo && !laudo.status_laudo.fl_pronto ) {
                this.$toast.add({
                    severity: "warn",
                    summary: laudo.atendimento_procedimento.procedimento.search,
                    detail: "Laudo: " + laudo.status_laudo.search,
                    life: 5000
                });
                return;
            }

            this.$util.print_preview('imprimir/laudo/' + laudo.id_laudo, true);
        },

        imprimir_laudo_lab (id_atendimento) { 
            this.$util.print_preview('imprimir/laudo_lab/' + id_atendimento, true);
        },

        entregar (laudo) {
            this.$refs.entrega.registrar_entrega(laudo);
        },

        imprimirLista() {
            this.$htmlToPaper('lista-de-trabalho', null);
        },

        // Arquivos
        abrir_anexar_arquivo(laudo) {
            this.marcacao = laudo.atendimento_procedimento.atendimento.marcacao;
            this.acao_anexar = false;

            this.$nextTick(() => { 
                this.acao_anexar = true;

                if ( this.marcacao.arquivos && this.marcacao.arquivos.length && !this.marcacao.arquivos.find(arq => arq.arquivo) ) {
                    this.carregar_arquivos(true);
                    return;
                }

                this.$nextTick(() => {
                    this.$refs.upload.abrir();
                });
            });
        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.marcacao.id_marcacao,
                    type: 'marcacao',
                }
            })
            .then(res => {
                this.marcacao.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                    this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });

        },

        //

        alterar_medico(marcacao, laudo) {
            this.$refs.alterar_prof.alterar(
                marcacao, 
                () => {
                    this.$util.remarcar(marcacao, true);
                },
                { 
                    laudo: true, 
                    id_laudo: laudo.id_laudo, 
                }
            );
        },

        refresh_se_necessario () {
            if ( !this.tem_paginacao )
                return;

            this.page = 1;
            this.$store.commit("loading", true);

            if (this.search_timeout) clearTimeout(this.search_timeout);

            this.search_timeout = setTimeout(() => {
                this.load();
                this.search_timeout = null;
            }, 300);

        },

        paginar (page) {
            this.page = page;
            this.load(false);
        },

        listar_laudos () {

            if ( !this.lista )
                return [];

            return this.lista.filter(item => item.atendimento_procedimento
                    && ( !this.laudo || item.atendimento_procedimento.id_atendimento == this.laudo.atendimento_procedimento.id_atendimento )
                );

        },

        laudo_status(status) {

            if ( this.is_fila_outros ) {

                this.$util.atualizar(this, {
                    service: 'laudos',
                    func: 'status_outros',
                    dados: {
                        ...this.laudo,
                        fila: this.fila,
                        id_status_laudo: status.id_status_laudo,
                        local: this.$util.getCookie('local-chamada'),
                        pos_atend: this.fila ? this.fila.fl_pos_atendimento : null,
                    },
                    toast: true,
                    modal: 'procedimentoModal',
                    callback: res => {
                        if ( res == 'OK' || res.id_status_laudo ) {
                            this.load();
                        }
                    }
                });

                return;

            }

            let lista_laudos;
            let laudo = this.laudo; 

            if ( !this.laudo ) { 

                laudo = _.first(this.selecionados);

                if ( !laudo ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Nenhum laudo selecionado.",
                        life: 3000
                    });
                    return;
                }

                lista_laudos = this.selecionados.map(item => item.id_laudo);
                
            } else { 

                if ( this.fila && this.fila.fl_fila_procedimento ) {
                    lista_laudos = this.lista.filter(item => item.atendimento_procedimento
                            && item.atendimento_procedimento.id_atendimento == this.laudo.atendimento_procedimento.id_atendimento
                            && ( item.sel || item.id_laudo == this.laudo.id_laudo )
                        )
                        .map(item => item.id_laudo);
                }

            }

            const id_recepcao = this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null;

            this.validate = true; 

            this.$nextTick(() => {

                let invalids = $('#procedimentoModal .invalid');
        
                if (invalids.length && $(".invalid").is(":visible")) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                    return; 
                }

                this.$util.atualizar(this, {
                    service: 'laudos',
                    func: 'status',
                    dados: {
                        id_laudo: laudo.id_laudo,
                        id_status_laudo: status.id_status_laudo,
                        local: this.$util.getCookie('local-chamada'),
                        fila: this.fila ? this.fila.id_fila_laudo : null,
                        pos_atend: this.fila ? this.fila.fl_pos_atendimento : null,
                        lista: lista_laudos,
                        id_recepcao: id_recepcao,
                        block_painel: this.$util.getCookie('nao-enviar-painel'),
                        teste_modelo: true, 
                        status_modelo: this.status_modelo,
                        resps: ( this.resps && ( !this.resps.id_laudo || ( this.resps.id_laudo == this.laudo.id_laudo ) ) ) ? this.resps.resps : null,
                    },
                    callback: res => {

                        if ( res.modelo || res.info_resp ) { 
                            this.status_selec = status; 
                            this.status_modelo = res.modelo; 
                            this.validate = false;  
                            return; 
                        }

                        $('#procedimentoModal').modal('hide');

                        if ( res == 'OK' || res.id_status_laudo ) {
                            this.$nextTick(() => { 
                                this.load();
                            });
                        }

                    }
                });

            });

        },

        consultarImagensChave(laudo) {
            this.$util.atualizar(this, {
                service: 'pep',
                func: 'pacs_imagens_chave',
                dados: {
                    id_laudo: laudo.id_laudo,
                },
                callback: (res) => {
                    if(res && res.status_code == 200) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: res.msg ? res.msg : "Imagens Chave Consultadas com Sucesso",
                            life: 3000
                        });
                    }
                }
            });
        },

        abrirLaudo(laudo, ir_para_laudo = false) {
            if ( this.fila && ( !laudo || ( this.fila.fl_fila_procedimento && !ir_para_laudo ) ) ) {
                this.laudo = laudo;
                this.status_modelo = null; 
                this.status_selec = null; 
                this.validate = false; 
                this.resps = { resps: [] }; 

                let lista = this.listar_laudos();

                if ( laudo ) { 

                    lista.forEach(ld => {
                        if ( ld.id_laudo == laudo.id_laudo ) {
                            ld.sel = true;
                        } else {
                            ld.sel = ( this.fila.fl_acao_individual ? false : true );
                        }
                    });

                }

                if ( laudo && this.fila.in_ordem_atend ) { 

                    this.$util.loadItem(this, { 
                        service: 'laudos',
                        func: 'check_filas',
                        parms: { 
                            id_fila_laudo: this.filtro.id_fila_laudo,
                            id_atendimento: laudo.atendimento_procedimento.id_atendimento,
                        }
                    })
                    .then(res => {
                        this.laudo.fila_block = res.fila; 
                        this.$forceUpdate(); 
                    });

                }

                if ( laudo ) { 
                    this.resps = _.cloneDeep(laudo); 
                }

                this.lista_selecao = _.cloneDeep(lista); 

                $('#procedimentoModal').modal('show');
                return;
            }

            const lista = this.lista.map(item => {
                return {
                    id_laudo: item.id_laudo,
                    id_fila: this.filtro.id_fila_laudo,
                    id_paciente: item.atendimento_procedimento.atendimento.paciente.id_pessoa,
                    nome_paciente: item.atendimento_procedimento.atendimento.paciente.st_nome,
                    nome_medico: item.atendimento_procedimento.atendimento.medico.search,
                    nome_procedimento: item.atendimento_procedimento.procedimento.search,
                    dt_inclusao: item.dt_inclusao,
                    status_laudo: item.status_laudo,
                    ativo: item.atendimento_procedimento.fl_ativo, 
                    prazo: item.atendimento_procedimento.dt_entrega, 
                    id_atendimento: item.atendimento_procedimento.id_atendimento, 
                    sinalizador: _.get(item, 'atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento'),
                };
            });

            const params = {
                id: laudo.id_laudo,
                fila: this.filtro.id_fila_laudo,
                lista: lista,
                filtro: this.filtro,
            };

            this.$router.push({
                name: 'laudo',
                params: params,
            });

            /*
            this.$router.push({
                path: '/laudos/' + laudo.id_laudo + '/' + this.filtro.id_fila_laudo,
                params: lista,
            });
            */
        },

        dados_paciente(laudo) {
            return {
                marcacao: {
                    plano: laudo.atendimento_procedimento.atendimento.plano,
                    paciente: laudo.atendimento_procedimento.atendimento.paciente,
                    fl_preferencial: laudo.atendimento_procedimento.atendimento.marcacao
                        ? laudo.atendimento_procedimento.atendimento.marcacao.fl_preferencial
                        : false,
                }
            };
        },

        dados_procedimento(laudo) {
            return {
                marcacao: {
                    nome_paciente: laudo.atendimento_procedimento.atendimento.paciente.st_nome,
                    id_marcacao: laudo.atendimento_procedimento.atendimento.marcacao.id_marcacao,
                    id_atendimento: laudo.atendimento_procedimento.atendimento.id_atendimento,
                    procedimento: laudo.atendimento_procedimento.procedimento,
                    medico: laudo.atendimento_procedimento.medico ? laudo.atendimento_procedimento.medico : laudo.atendimento_procedimento.atendimento.medico,
                    arquivos: laudo.atendimento_procedimento.atendimento.marcacao.arquivos,
                    doc_pre_atends: laudo.atendimento_procedimento.atendimento.marcacao.doc_pre_atends,
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao,
                    st_regiao: laudo.atendimento_procedimento.st_regiao, 
                    atendimento: { 
                        apoiado: laudo.atendimento_procedimento.atendimento.apoiado,
                        atendimento_procedimentos_count: laudo.atendimento_procedimento.atendimento.atendimento_procedimentos_count,
                    }, 
                    atend_proc_laudos: laudo.atendimento_procedimento.atendimento.atendimento_procedimentos,   
                }
            };
        },

        load(extra_parms = {}, callback = null) {

            if ( ($("#liberaLaudoModal").data('bs.modal') || {})._isShown ) { 
                console.log('liberaLaudoModal is shown');
                return;
            }

            if ( ($("#procedimentoModal").data('bs.modal') || {})._isShown ) { 
                console.log('procedimentoModal is shown');
                return;
            }

            if ( ($("#imprimirEtiquetasLoteModal").data('bs.modal') || {})._isShown ) { 
                console.log('imprimirEtiquetasLoteModal is shown');
                return;
            }

            if ( ($("#laudoSinalizadorLoteModal").data('bs.modal') || {})._isShown ) { 
                console.log('laudoSinalizadorLoteModal is shown');
                return;
            }

            this.salvar_agrupar();

            this.$store.commit('setContexto', { fila_id_medico: this.filtro.id_medico })

            // console.log('contexto', this.$store.state.contexto);

            if ( this.refresher ) {
                clearInterval(this.refresher);
                this.refresher = null;
            }

            this.$util.setCookie('laudo-fila', this.filtro.id_fila_laudo);
            this.$util.setCookie('unidade-fila-laudo', this.filtro.id_unidade_operacao);
            this.$util.setCookie('recepcao-fila-laudo', this.filtro.id_recepcao);

            if ( this.$store.state.user.medico ) {
                this.$util.setCookie('laudo-fila-meus-' + this.$store.state.user.id_usuario, this.meus ? 'S' : 'N');
            }

            this.$util.setCookie('wl-per', this.filtro.periodo);

            let fila = this.filas.find(item => item.id_fila_laudo == this.filtro.id_fila_laudo);

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            if ( fila && fila.fl_fila_procedimento && fila.receps_count ) {
                this.$util.load(this, {
                    service: 'atendimento_outros',
                    func: 'index',
                    canceltoken: this.canceltoken.token,
                    parms: {
                        fila: true,
                        ...this.filtro,
                        medicos: ( this.filtro_lista_medicos && this.filtro_lista_medicos.length ) ? this.filtro_lista_medicos : null , 
                        page: this.page,
                        size: 100,
                        search: this.search,
                        id_paciente: this.paciente ? this.paciente.id_pessoa : null,
                        meus: this.meus,
                        id_fila_laudo: fila.id_fila_laudo,
                        add_filtros: this.$refs.filtros.get_filtros(0),
                    },
                    final: () => {
                        this.firstLoad = true;

                        if ( this.dados && this.dados.last_page > 1 ) {
                            this.tem_paginacao = true;
                        }
                    }
                });
                return;
            }

            if ( fila && fila.fl_fila_procedimento ) {
                this.$util.load(this, {
                    service: 'laudos',
                    func: 'index',
                    canceltoken: this.canceltoken.token,
                    parms: {
                        fila: true,
                        ...this.filtro,
                        medicos: ( this.filtro_lista_medicos && this.filtro_lista_medicos.length ) ? this.filtro_lista_medicos : null , 
                        page: this.page,
                        size: 100,
                        search: this.search,
                        id_paciente: this.paciente ? this.paciente.id_pessoa : null,
                        meus: this.meus,
                        ...extra_parms,
                        add_filtros: this.$refs.filtros.get_filtros(0),
                    },
                    loadTo: res => { 
                        if ( res.amostras_ap ) { 
                            this.dados = null; 
                            this.amostras_ap = res.amostras_ap;
                            this.$refs.amoap.abrir(this.amostras_ap, this.search);
                        } else { 
                            this.dados = res;
                        }
                    },
                    final: () => {
                        this.firstLoad = true;

                        if ( this.dados && this.dados.last_page > 1 ) {
                            this.tem_paginacao = true;
                        }
                    }
                });
                return;
            }

            this.$util.load(this, {
                service: 'laudos',
                func: 'index',
                canceltoken: this.canceltoken.token,
                parms: {
                    fila: true,
                    from: this.from,
                    to: this.to,
                    ...this.filtro,
                    medicos: ( this.filtro_lista_medicos && this.filtro_lista_medicos.length ) ? this.filtro_lista_medicos : null , 
                    page: this.page,
                    size: 100,
                    search: this.search,
                    id_paciente: this.paciente ? this.paciente.id_pessoa : null,
                    meus: this.meus,
                    add_filtros: this.$refs.filtros.get_filtros(0),
                },
                loadTo: res => { 
                    this.dados = res;

                    if ( callback ) { 
                        callback(res);
                    }
                },
                final: () => {
                    this.firstLoad = true;

                    if ( this.dados && this.dados.last_page > 1 ) {
                        this.tem_paginacao = true;
                    }

                    this.refresher = setInterval(() => {
                        if ( !this.$store.state.loading ) {
                            if ( this.filtro.periodo.substring(0,1) == 'm' 
                                || this.filtro.periodo.substring(0,1) == 'a'
                                || this.filtro.periodo.substring(0,1) == 'l'
                                || !this.filtro.periodo 
                                || this.paciente ) { 
                                // console.log('Não Buscou!');
                            } else { 
                                this.load();
                            }
                        }
                        console.log('Refresh', new Date().toISOString());
                    }, 60000);
                }
            });
        },

        subscribe_refresh() {

            // Subscribe Channel
            subscribe(this.$store.state.dominio, "chamar-paciente", retorno => {

                if ( !retorno || !retorno.data )
                    return;

                if ( retorno.data.acao != 'pausar' ) {
                    return;
                }

                const index = this.lista.findIndex(item => {
                    if ( retorno.data.id_marcacao ) {
                        return ( item.atendimento_procedimento.atendimento.marcacao
                            && item.atendimento_procedimento.atendimento.marcacao.id_marcacao == retorno.data.id_marcacao );
                    }
                });

                if ( index < 0 ) {
                    if ( this.filtro.id_unidade_operacao && this.filtro.id_unidade_operacao != retorno.data.id_unidade_operacao )
                        return;

                    if ( this.$store.state.user.medico && this.$store.state.user.id_medico != retorno.data.id_medico )
                        return;

                    if ( !retorno.data.atend_proc_laudos || !retorno.data.atend_proc_laudos.length )
                        return;

                    /*
                    if ( this.$store.state.loading )
                        return;
                    */

                    if ( this.fila && this.fila.fl_fila_procedimento ) {
                        this.load();
                    }
                }

            });

        },

    },

    beforeMount() {

        this.agrupar_por_status = this.$util.getCookie('ld-aps') == 'S';

        if ( this.$store.state.user.medico ) {
            this.meus = this.$util.getCookie('laudo-fila-meus-' + this.$store.state.user.id_usuario) != 'N';
        }

        if ( this.$route.params.filtro ) {
            this.filtro = this.$route.params.filtro;
            this.buscar_ao_abrir = true;
        } else {
            this.filtro.periodo = this.$util.getCookie('wl-per') ? this.$util.getCookie('wl-per') : 'do';
        }

        this.filtro.block_prontos = this.$util.getCookie('ld-op') == 'S';
        this.filtro.tipo_ordem = this.$util.getCookie('ld-to') ? this.$util.getCookie('ld-to') : 'DE';
        this.filtro.ordem_dir = this.$util.getCookie('ld-od') ? this.$util.getCookie('ld-od') : 'D';

        if ( this.$store.state.user && this.$store.state.user.medico && this.meus ) {
            this.buscar_ao_abrir = true;
        }

    },

    beforeDestroy() {
        if ( this.refresher ) {
            clearInterval(this.refresher);
            this.refresher = null;
        }
    },

    mounted() {

        this.$store.commit("setBreadcrumb", [
            { name: "Laudos", path: "/laudos/lista" }
        ]);

        this.$util.loadItem(this, {
            service: 'fila_laudos',
            func: 'index',
            parms: {
                todas: true,
            }
        })
        .then(res => {
            this.filas = res;

            if ( this.buscar_ao_abrir )
                this.load();
        });

        this.$util.loadItem(this, { 
            service: 'tarefas',
            func: 'index',
            parms: { 
                pendentes: true, 
                minhas: true, 
                id_medico: this.$store.state.user.medico ? this.$store.state.user.id_pessoa : null, 
            },
        })
        .then(res => { 
            this.tarefas = res;
        });

        this.subscribe_refresh();

        this.$nextTick(() => {
            this.montando = false;
        });

    },

    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },
}
</script>